module.exports = __webpack_public_path__ + "img/cover-redeem-bg-mobile.5b488a89.jpg";